import { instanceConexao } from "services/axiosServices";
import { AxiosRequestConfig } from "axios";
import { FileUploadI } from "../utils";

export const putFotoPerfilAutonomo = async ({
  idAutonomo,
  arquivo,
  authToken,
}: {
  idAutonomo: string;
  arquivo: FileUploadI | null;
  authToken: string;
}): Promise<any> => {
  const url = "api/alteracaoAutonomo/AlterarFotoAlteracaoAutonomo";
  const config: AxiosRequestConfig = {
    headers: {
      Authorization: `Bearer ${authToken}`,
    },
  };
  const response = await instanceConexao.put(
    url,
    { idAutonomo, arquivo },
    config
  );
  return response?.data;
};
